import React from "react";
import { Box, Typography, Container, Grid, Paper, Button, Link } from "@mui/material";
import BookSessionButton from "./BookSessionButton";

const ThankYouForPurchaseSection = () => (
    <Box
        component="section"
        sx={{
            py: { xs: 6, md: 10 },
            bgcolor: "custom.blue",
            width: "100%",
            marginBottom: 5
        }}
        id="thank-you-section"
    >
        <Container maxWidth="md">
            <Paper
                elevation={3}
                sx={{
                    p: { xs: 3, md: 6 },
                    borderRadius: 3,
                }}
            >
                <Grid container spacing={3} justifyContent="center">
                    <Grid item xs={12}>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                color: "custom.blue",
                                fontWeight: 600,
                                letterSpacing: 1,
                                textAlign: "center",
                                fontSize: 16,
                            }}
                        >
                            YOU ARE IN!
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography
                            variant="h4"
                            sx={{
                                color: "custom.red",
                                fontWeight: 700,
                                textAlign: "center",
                                mb: 1,
                                fontSize: { xs: 28, md: 32 },
                            }}
                        >
                            Thank You For Your Purchase!
                        </Typography>
                        <Typography
                            variant="h4"
                            sx={{
                                color: "#000",
                                fontWeight: 700,
                                textAlign: "center",
                                fontSize: { xs: 22, md: 32 },
                            }}
                        >
                            Your Parenting Journey Just Got Brighter&nbsp;
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Typography
                            variant="body1"
                            sx={{
                                color: "#000",
                                fontWeight: 400,
                                textAlign: "center",
                                fontSize: 20,
                                mt: 3,
                            }}
                        >
                            <strong>Your eBook is on its way to your inbox right now!</strong>
                            <br />
                            <br />
                            (If it’s not there in 5 minutes, peek into your spam or promotions tab, sometimes the good stuff hides).
                        </Typography>
                    </Grid>
                    <BookSessionButton />
                </Grid>
            </Paper>
        </Container>
    </Box>
);

export default ThankYouForPurchaseSection;